import React, { useState } from 'react';
import { ArrowLeft, Info, Filter, X, ChevronRight, Clock, Package, ExternalLink, CheckCircle, XCircle, AlertCircle, RefreshCw, Search, Clipboard, FileText, MessageSquare, Send, Check, Calendar, Mail, User, Edit, Square, CircleAlert, Zap, Layers, ClipboardList } from 'lucide-react';
import { Link } from 'react-router-dom';
export const Activity = ({
  onClose
}) => {
  const [filters, setFilters] = useState({
    dateRange: 'Last 7 days',
    runType: 'Exclude test runs'
  });
  const [selectedTask, setSelectedTask] = useState(null);
  const clearFilters = () => {
    setFilters({
      dateRange: '',
      runType: ''
    });
  };
  const activityData = [{
    id: 1,
    task: 'Inventory Restock Alert',
    type: 'Basic',
    status: 'Pending approval',
    trigger: 'Scheduled time',
    triggerIcon: <Clock className="w-4 h-4 text-gray-700" data-id="element-166" />,
    lastUpdate: 'Sep 14, 2025, 8:02:04 AM'
  }, {
    id: 2,
    task: 'Weekly Feedback Analysis and Summary',
    type: 'Builder',
    status: 'Pending approval',
    trigger: 'Order placed',
    triggerIcon: <Package className="w-4 h-4 text-gray-700" data-id="element-167" />,
    lastUpdate: 'Sep 12, 2025, 5:38:16 PM'
  }, {
    id: 3,
    task: 'Weekly Feedback Analysis and Summary',
    type: 'Builder',
    status: 'Pending approval',
    trigger: 'Order placed',
    triggerIcon: <Package className="w-4 h-4 text-gray-700" data-id="element-168" />,
    lastUpdate: 'Sep 12, 2025, 5:38:10 PM'
  }, {
    id: 4,
    task: 'Monthly Sales Performance Report',
    type: 'Builder',
    status: 'Failed',
    trigger: 'Order placed',
    triggerIcon: <Package className="w-4 h-4 text-gray-700" data-id="element-169" />,
    lastUpdate: 'Sep 11, 2025, 12:36:57 PM'
  }, {
    id: 5,
    task: 'Low Rating Review Response',
    type: 'Basic',
    status: 'Canceled',
    trigger: 'Order placed',
    triggerIcon: <Package className="w-4 h-4 text-gray-700" data-id="element-170" />,
    lastUpdate: 'Sep 11, 2025, 12:36:43 PM'
  }, {
    id: 6,
    task: 'Negative Review Response with Coupon',
    type: 'Builder',
    status: 'Completed',
    trigger: 'Order placed',
    triggerIcon: <Package className="w-4 h-4 text-gray-700" data-id="element-171" />,
    lastUpdate: 'Sep 11, 2025, 12:27:50 PM'
  }, {
    id: 7,
    task: 'Inventory Restock Management',
    type: 'Basic',
    status: 'Canceled',
    trigger: 'Order placed',
    triggerIcon: <Package className="w-4 h-4 text-gray-700" data-id="element-172" />,
    lastUpdate: 'Sep 11, 2025, 12:26:41 PM'
  }];
  const handleViewDetails = task => {
    setSelectedTask(task);
  };
  const closeTaskDetails = () => {
    setSelectedTask(null);
  };
  return <div className="max-w-full relative flex" data-id="element-173">
      {/* Main Content */}
      <div className={`flex-1 ${selectedTask ? 'pr-4' : ''}`} data-id="element-174">
        {/* Breadcrumb */}
        <div className="flex items-center text-sm text-gray-500 mb-4" data-id="element-175">
          <Link to="/" className="hover:text-gray-700" data-id="element-176">
            AI Custom Agent
          </Link>
          <ChevronRight className="w-4 h-4 mx-2" data-id="element-177" />
          <span className="text-gray-700" data-id="element-178">Activity</span>
        </div>
        {/* Header */}
        <div className="mb-6" data-id="element-179">
          <h1 className="text-3xl font-bold text-gray-800 mb-2" data-id="element-180">Activity</h1>
          <p className="text-gray-600" data-id="element-181">
            Monitor all agent invocations and review agent actions requiring
            your approval.
          </p>
        </div>
        {/* Task runs section */}
        <div className="bg-white border border-gray-200 rounded-lg mb-6" data-id="element-182">
          <div className="p-4 border-b border-gray-200" data-id="element-183">
            <h2 className="text-lg font-medium text-gray-800" data-id="element-184">
              Agent invocations
            </h2>
          </div>
          {/* Filters */}
          <div className="p-4 flex items-center justify-between" data-id="element-185">
            <div className="flex flex-wrap gap-2" data-id="element-186">
              {filters.dateRange && <div className="flex items-center bg-gray-100 rounded-full px-3 py-1 text-sm" data-id="element-187">
                  {filters.dateRange}
                  <button onClick={() => setFilters({
                ...filters,
                dateRange: ''
              })} className="ml-2 text-gray-500 hover:text-gray-700" data-id="element-188">
                    <X className="w-3 h-3" data-id="element-189" />
                  </button>
                </div>}
              {filters.runType && <div className="flex items-center bg-gray-100 rounded-full px-3 py-1 text-sm" data-id="element-190">
                  {`Run type: ${filters.runType}`}
                  <button onClick={() => setFilters({
                ...filters,
                runType: ''
              })} className="ml-2 text-gray-500 hover:text-gray-700" data-id="element-191">
                    <X className="w-3 h-3" data-id="element-192" />
                  </button>
                </div>}
              {(filters.dateRange || filters.runType) && <button onClick={clearFilters} className="text-gray-500 hover:text-gray-700 text-sm" data-id="element-193">
                  Clear
                </button>}
            </div>
            <div className="flex gap-2" data-id="element-194">
              <button className="flex items-center px-3 py-1 border border-gray-200 rounded-md text-sm" data-id="element-195">
                <Filter className="w-4 h-4 mr-1" data-id="element-196" />
                Filter
                <span className="ml-1 bg-gray-200 text-gray-700 rounded-full w-5 h-5 flex items-center justify-center text-xs" data-id="element-197">
                  2
                </span>
              </button>
              <div className="relative" data-id="element-198">
                <input type="text" placeholder="Search..." className="pl-3 pr-8 py-1 border border-gray-200 rounded-md text-sm w-60" data-id="element-199" />
              </div>
            </div>
          </div>
          {/* Table */}
          <div className="overflow-x-auto" data-id="element-200">
            <table className="w-full" data-id="element-201">
              <thead data-id="element-202">
                <tr className="border-t border-b border-gray-200 bg-gray-50 text-left" data-id="element-203">
                  <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-204">
                    Workflow
                  </th>
                  <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-205">
                    Type
                  </th>
                  <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-206">
                    Status
                  </th>
                  <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-207">
                    <div className="flex items-center" data-id="element-208">
                      Last update
                      <button className="ml-1" data-id="element-209">
                        <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-210">
                          <path d="M4 0L7.4641 6H0.535898L4 0Z" fill="#6B7280" data-id="element-211" />
                          <path d="M4 12L0.535898 6L7.4641 6L4 12Z" fill="#D1D5DB" data-id="element-212" />
                        </svg>
                      </button>
                    </div>
                  </th>
                  <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider w-10" data-id="element-213"></th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200" data-id="element-214">
                {activityData.map(item => <tr key={item.id} className="hover:bg-gray-50 cursor-pointer group" onClick={() => handleViewDetails(item)} data-id="element-215">
                    <td className="px-6 py-4 text-sm text-gray-800" data-id="element-216">
                      {item.task}
                    </td>
                    <td className="px-6 py-4" data-id="element-217">
                      <TypeBadge type={item.type} data-id="element-218" />
                    </td>
                    <td className="px-6 py-4" data-id="element-219">
                      <StatusBadge status={item.status} data-id="element-220" />
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-600" data-id="element-221">
                      {item.lastUpdate}
                    </td>
                    <td className="px-6 py-4 text-right" data-id="element-222">
                      <button className="text-gray-400 hover:text-gray-600 group-hover:opacity-100 opacity-0 bg-gray-100 hover:bg-gray-200 px-2 py-1 rounded-md text-xs transition-opacity duration-200 whitespace-nowrap" data-id="element-223">
                        <ExternalLink className="w-3 h-3 inline mr-1" data-id="element-224" />
                        View Details
                      </button>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      {/* Task Details Panel */}
      {selectedTask && <div className="w-full max-w-[270px] border-l border-gray-200 bg-white shadow-lg" data-id="element-225">
          <div className="flex flex-col h-full" data-id="element-226">
            {/* Header */}
            <div className="flex justify-between items-center p-4 border-b border-gray-200" data-id="element-227">
              <div className="flex-1" data-id="element-228">
                <h2 className="text-lg font-medium text-gray-800" data-id="element-229">
                  {selectedTask.task}
                </h2>
                <p className="text-sm text-gray-500" data-id="element-230">
                  {selectedTask.lastUpdate}
                </p>
              </div>
              <div className="flex items-center" data-id="element-231">
                <button className="flex items-center px-2 py-1 bg-blue-500 hover:bg-blue-600 rounded-md text-xs text-white mr-2" title="View Run Log" data-id="element-232">
                  <ClipboardList className="w-3 h-3 mr-1" data-id="element-233" />
                  Run log
                </button>
                <button onClick={closeTaskDetails} className="text-gray-400 hover:text-gray-600" data-id="element-234">
                  <X className="w-5 h-5" data-id="element-235" />
                </button>
              </div>
            </div>
            {/* Content */}
            <div className="flex-1 overflow-auto" data-id="element-236">
              {/* Execution Steps */}
              <div className="border-b border-gray-100" data-id="element-237">
                <ExecutionStep status="completed" title="Product details for the item 'Bag' retrieved successfully, including pricing and stock information." data-id="element-238" />
              </div>
              <div className="border-b border-gray-100" data-id="element-239">
                <ExecutionStep status="completed" title="Searching for supplier information in Wix documentation" description="Supplier information and management capabilities were successfully located in the documentation." data-id="element-240" />
              </div>
              <div className="border-b border-gray-100" data-id="element-241">
                <ExecutionStep status="completed" title="Searching Wix REST documentation" description="Successfully retrieved detailed information about Wix Stores Catalog V3, including product management capabilities and API resources." data-id="element-242" />
              </div>
              <div className="border-b border-gray-100" data-id="element-243">
                <ExecutionStep status="completed" title="Searching Wix REST documentation for brands" description="Successfully retrieved information about the brands API, including methods for querying and managing brands." data-id="element-244" />
              </div>
              <div className="border-b border-gray-100" data-id="element-245">
                <ExecutionStep status="pending" title="Sending restock request email" description="Email with urgent restock request for Vase ready for approval." isActionable={true} data-id="element-246" />
              </div>
            </div>
            {/* Footer Actions */}
            <div className="p-4 border-t border-gray-200" data-id="element-247">
              {selectedTask.status === 'Pending approval' && <div className="flex flex-col gap-4" data-id="element-248">
                  <div className="flex justify-between" data-id="element-249">
                    <button className="flex items-center text-sm text-blue-600 hover:text-blue-800" data-id="element-250">
                      <Edit className="w-4 h-4 mr-1" data-id="element-251" />
                      Review & Edit
                    </button>
                  </div>
                  <div className="flex gap-2" data-id="element-252">
                    <button className="flex-1 py-2 bg-blue-500 text-white rounded-md text-sm font-medium flex items-center justify-center" data-id="element-253">
                      Approve
                    </button>
                    <button className="flex-1 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700" data-id="element-254">
                      Reject
                    </button>
                  </div>
                  <div className="flex justify-between mt-2" data-id="element-255">
                    <button className="flex items-center text-sm text-blue-600 hover:text-blue-800" data-id="element-256">
                      <Square className="w-4 h-4 mr-1" data-id="element-257" />
                      View Details
                    </button>
                    <button className="flex items-center text-sm text-blue-600 hover:text-blue-800" data-id="element-258">
                      <Square className="w-4 h-4 mr-1" data-id="element-259" />
                      Stop
                    </button>
                  </div>
                </div>}
              {selectedTask.status !== 'Pending approval' && <div className="flex justify-between" data-id="element-260">
                  <button className="flex items-center text-sm text-blue-600 hover:text-blue-800" data-id="element-261">
                    <Square className="w-4 h-4 mr-1" data-id="element-262" />
                    View Details
                  </button>
                  <button className="flex items-center text-sm text-blue-600 hover:text-blue-800" data-id="element-263">
                    <Square className="w-4 h-4 mr-1" data-id="element-264" />
                    Stop
                  </button>
                </div>}
            </div>
          </div>
        </div>}
    </div>;
};
const StatusBadge = ({
  status
}) => {
  let bgColor = 'bg-gray-100';
  let textColor = 'text-gray-800';
  let borderColor = 'border-gray-200';
  let icon = null;
  if (status === 'Completed') {
    bgColor = 'bg-gray-100';
    textColor = 'text-gray-800';
    borderColor = 'border-gray-200';
    icon = <CheckCircle className="w-3 h-3 mr-1" data-id="element-265" />;
  } else if (status === 'Failed') {
    bgColor = 'bg-gray-100';
    textColor = 'text-gray-800';
    borderColor = 'border-gray-200';
    icon = <XCircle className="w-3 h-3 mr-1" data-id="element-266" />;
  } else if (status === 'Canceled') {
    bgColor = 'bg-gray-50';
    textColor = 'text-gray-600';
    borderColor = 'border-gray-300';
    icon = <X className="w-3 h-3 mr-1" data-id="element-267" />;
  } else if (status === 'Pending approval') {
    bgColor = 'bg-gray-100';
    textColor = 'text-gray-800';
    borderColor = 'border-gray-200';
    icon = <AlertCircle className="w-3 h-3 mr-1" data-id="element-268" />;
  }
  return <span className={`inline-flex items-center px-2 py-1 rounded-md text-xs font-medium ${bgColor} ${textColor} border ${borderColor}`} data-id="element-269">
      {icon}
      {status}
    </span>;
};
const TypeBadge = ({
  type
}) => {
  let bgColor = 'bg-gray-100';
  let textColor = 'text-gray-700';
  let borderColor = 'border-gray-200';
  let icon = <Zap className="w-3 h-3 mr-1 text-yellow-500" data-id="element-270" />;
  if (type === 'Builder') {
    icon = <Layers className="w-3 h-3 mr-1 text-blue-500" data-id="element-271" />;
  }
  return <span className={`inline-flex items-center px-2 py-1 rounded-md text-xs font-medium ${bgColor} ${textColor} border ${borderColor}`} data-id="element-272">
      {icon} {type}
    </span>;
};
const ExecutionStep = ({
  status,
  title,
  description,
  isActionable = false
}) => {
  let StatusIcon = CheckCircle;
  let statusColor = 'text-green-500';
  if (status === 'completed') {
    StatusIcon = CheckCircle;
    statusColor = 'text-green-500';
  } else if (status === 'failed') {
    StatusIcon = XCircle;
    statusColor = 'text-red-500';
  } else if (status === 'pending') {
    StatusIcon = CircleAlert;
    statusColor = 'text-yellow-500';
  }
  return <div className="p-4" data-id="element-273">
      <div className="flex" data-id="element-274">
        <div className={`mt-1 mr-3 flex-shrink-0 ${statusColor}`} data-id="element-275">
          <StatusIcon className="w-5 h-5" data-id="element-276" />
        </div>
        <div className="flex-1" data-id="element-277">
          <h3 className="text-sm font-medium text-gray-800" data-id="element-278">{title}</h3>
          {description && <p className="text-sm text-gray-600 mt-1" data-id="element-279">{description}</p>}
          {isActionable && <div className="mt-2" data-id="element-280">
              <button className="px-2 py-1 text-xs bg-gray-100 text-gray-700 rounded hover:bg-gray-200 flex items-center" data-id="element-281">
                <Send className="w-3 h-3 mr-1" data-id="element-282" />
                View Email
              </button>
            </div>}
        </div>
      </div>
    </div>;
};